import ApiService from '@/app/framework/services/ApiServices'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import { injectable } from 'tsyringe'
import { RoleRepositoryInterface } from '@/data/persistences/repositories/contracts/RoleRepositoryInterface'
import { Role } from '@/domain/entities/Role'
import { RoleDataMapper } from '@/data/persistences/mappers/RoleDataMapper'

@injectable()
export class RoleApiRepository implements RoleRepositoryInterface {
  private service: ApiService
  private mapper: RoleDataMapper

  constructor(service: ApiService, mapper: RoleDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<Role[]> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.ADMIN_ROLE,
      params
    )
    return this.mapper.converRoleListFromApi(resp)
  }
}
